import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { WP_FORM_ERROR_MESSAGES } from '../../../dashboard/dialogs/add-website-dialog/add-website-dialog.const';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { DialogData } from '../../../../shared/models/dialog-data.model';

@Component({
  selector: 'app-create-staging-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
    MatCheckboxModule,
  ],
  templateUrl: './create-staging-dialog.component.html',
  styleUrl: './create-staging-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateStagingDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<CreateStagingDialogComponent>);

  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  readonly wpErrors = WP_FORM_ERROR_MESSAGES;

  public stagingEnvironments: { label: string; value: string }[] = [
    { label: 'Clone - Create copy of the website’s current version', value: 'clone' },
    { label: 'New - Install fresh WP on the staging site', value: 'new' },
    { label: 'Empty - Create staging site without WP installation)', value: 'empty' },
  ];

  form = this.fb.nonNullable.group({
    type: [''],
    wpUsername: [''],
    wpPassword: [''],
    wpEmail: ['', [Validators.email]],
  });

  ngOnInit(): void {
    this.form.controls.type.valueChanges.subscribe((value) => {
      if (value === 'new') {
        this.form.controls.wpUsername.addValidators(Validators.required);
        this.form.controls.wpPassword.addValidators(Validators.required);
      } else {
        this.form.controls.wpUsername.removeValidators(Validators.required);
        this.form.controls.wpPassword.removeValidators(Validators.required);
      }
      this.form.controls.wpUsername.updateValueAndValidity();
      this.form.controls.wpPassword.updateValueAndValidity();
    });
  }

  submit(): void {
    if (this.form.invalid) return;
    this.dialogRef.close(this.form.getRawValue());
  }

  close(): void {
    this.dialogRef.close();
  }
}
